import React, { useState } from "react";
import contentData from "../content.json";
import { Fade } from "react-awesome-reveal";
import ReactMarkdown from "react-markdown";
import ImageModal from "./ImageModal";

const isPdf = (src) => Boolean(src) && src.toLowerCase().endsWith(".pdf");

const TradingCard = ({ item, onSelect }) => {
  const hasFile = Boolean(item.image);
  const pdf = isPdf(item.image);

  return (
    <div
      className={`trading-card ${hasFile ? "trading-card-clickable" : ""}`}
      onClick={() => hasFile && onSelect(item)}
      role={hasFile ? "button" : undefined}
      tabIndex={hasFile ? 0 : undefined}
      onKeyDown={(e) => {
        if (hasFile && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onSelect(item);
        }
      }}
    >
      {hasFile && !pdf ? (
        <img src={item.image} alt={item.title} className="trading-card-image" />
      ) : (
        <div className="trading-card-placeholder">
          {pdf ? "View PDF" : "Image coming soon"}
        </div>
      )}
      <div className="trading-card-body">
        <h5 className="trading-card-title">{item.title}</h5>
        {item.firm ? <p className="trading-card-firm">{item.firm}</p> : null}
        {item.detail ? <p className="trading-card-detail">{item.detail}</p> : null}
      </div>
    </div>
  );
};

const TradingGroup = ({ title, items, onSelect }) => (
  <div className="row">
    <div className="col-sm-12">
      <h4 className="about-bold trading-group-title">{title}</h4>
      <div className="trading-grid">
        {items.map((item, index) => (
          <TradingCard
            key={`${title}-${index}`}
            item={item}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  </div>
);

const Trading = () => {
  const trading = contentData.trading;
  const payouts = trading.payouts || [];
  const certificates = trading.certificates || [];
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <Fade triggerOnce={true}>
      <section id="trading" className="trading-section">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3 className="title-a" id="trading-title">
                  {trading.section.title}
                  <div className="line-mf"></div>
                </h3>
                <div className="subtitle-a">
                  <ReactMarkdown>{trading.section.description}</ReactMarkdown>
                </div>
              </div>
            </div>
          </div>

          <TradingGroup
            title="Certificates"
            items={certificates}
            onSelect={setSelectedImage}
          />
          <TradingGroup
            title="Payouts"
            items={payouts}
            onSelect={setSelectedImage}
          />
        </div>

        <ImageModal
          src={selectedImage?.image}
          alt={selectedImage?.title}
          isOpen={selectedImage !== null}
          onClose={() => setSelectedImage(null)}
          imageStyle={{
            width: "92vw",
            height: "92vh",
            maxWidth: "none",
            maxHeight: "none",
            objectFit: "contain",
          }}
        />
      </section>
    </Fade>
  );
};

export default Trading;
